import config from 'js/app/config';
import path from 'js/lib/path';

import type { BreadcrumbListItem } from 'bundles/seo/utils/schemaMarkupUtils';

export type BreadcrumbSegment = {
  name: string;
  href?: string;
  hidden?: boolean;
};

export type BreadcrumbLinkInput = {
  label: string;
  href?: string;
};

const toAbsoluteUrl = (href: string, origin: string) => {
  return href.startsWith('http') ? href : path.join(origin, href);
};

export const linksToBreadcrumbSegments = (
  links: BreadcrumbLinkInput[],
  currentPageTitle?: string
): BreadcrumbSegment[] => {
  return [
    ...links.map(({ label, href }) => ({ name: label, href })),
    ...(currentPageTitle ? [{ name: currentPageTitle }] : []),
  ];
};

export const resolveBreadcrumbTrail = (
  segments: BreadcrumbSegment[],
  origin: string = config.url.domain
): BreadcrumbListItem[] => {
  const visibleSegments = segments.filter(({ hidden }) => !hidden);

  return visibleSegments.map(({ name, href }) => ({
    name,
    ...(href ? { absoluteUrl: toAbsoluteUrl(href, origin) } : {}),
  }));
};
